import type { OrgMetricsResponse } from '../../utils/orgMetrics';
import type { UserMicrositeHeroMetricsResponse } from '../../utils/userMetrics';

// Captured from services/dtac/src/mock/teamworkgraph.com.har.
// Local dev cannot always reach the production metrics routes, so the atoms
// serve these fixtures before attempting the network while running on localhost.
export const LOCAL_HAR_ORG_METRICS = {
	organisationId: '2346a038-3c8c-498b-a79b-e7847859868d',
	totalRelationships: 4558998847,
	activeRelTypes: 359,
	jiraCodeLinks: 60429135,
	goalWorkItemLinks: 41388,
	relDataAsOf: '2026-05-03',
	computedAt: '2026-05-05T03:31:24.186Z',
	cacheStatus: 'READY',
	avgDailyRelChange: 18711887,
	avgRelChangePerSecond: 216.5728,
	avgDailyJiraCodeLinkChange: 171441,
	avgJiraCodeLinkChangePerSecond: 1.9843,
	totalJiraIssues: 1833883,
	avgArtifactsPerIssue: 37.9,
	totalNodes: 1713109136,
	activeNodeTypes: 96,
	teamCount: 10265,
	userCount: 0,
	nodeDataAsOf: '2026-05-02',
	avgDailyNodeGrowth: 978500,
	avgNodeGrowthPerSecond: 11.3252,
	daysSinceSnapshot: 3,
	estimatedNodesNow: 1716044636,
	activeContributors180d: 9437,
	activityDataAsOf: '2026-05-03',
	avgFetchQueriesPerDay: 5753850,
	avgFetchQueriesPerSecond: 66.5955,
	queryDataAsOf: '2026-05-03',
	pagesCreated180d: 585785784,
	pagesDataAsOf: '2026-05-03',
	loomsRecorded180d: 690662,
	totalMinutesRecorded: 12909223,
	meetingMinutesSaved: 19363834,
	loomDataAsOf: '2026-05-03T23:59:40.562Z',
	issuesMovedForward180d: 3716825,
	issueActivityDataAsOf: '2026-05-03',
	commentsCreated180d: 53450486,
	commentsDataAsOf: '2026-05-03',
	meetingNotesWithRecording180d: 397721,
	meetingNotesDataAsOf: '2026-05-03',
	connectorObjects180d: 34823,
	connectorDataAsOf: '2026-05-02',
	connectorObjectsByProvider: [
		{ providerName: 'Google Drive provider', objects30d: 26499 },
		{ providerName: 'Slack provider', objects30d: 6545 },
		{ providerName: 'Salesforce', objects30d: 1542 },
		{ providerName: 'Bitbucket Pipelines Integration', objects30d: 175 },
		{ providerName: 'Docusign provider', objects30d: 62 },
	],
	smartlinkPastes180d: 578,
	smartlinkDataAsOf: '2026-04-24',
	connectorsInstalled: 15,
	connectorsActive28d: 11,
	pctConnectorsActive28d: 73.3,
	onePAppsInstalled: 9,
	marketplaceAddonsInstalled: 6,
	threePConnectorsInstalled: 15,
	forgeAppsInstalled: 0,
	totalAppsInstalled: 30,
	connectorsDetail: [
		{
			connectorName: 'jira-dc',
			connectorCategory: 'rovo_3p',
			pctUsersAuthed28d: 0.2,
			isUnderutilised: false,
			globalPctOrgsWithAnyAuthedUser: 38.5,
		},
		{
			connectorName: 'google-drive',
			connectorCategory: 'rovo_3p',
			pctUsersAuthed28d: 83.2,
			isUnderutilised: false,
			globalPctOrgsWithAnyAuthedUser: 79,
		},
		{
			connectorName: 'salesforce',
			connectorCategory: 'rovo_3p',
			pctUsersAuthed28d: 10.7,
			isUnderutilised: false,
			globalPctOrgsWithAnyAuthedUser: 81.3,
		},
		{
			connectorName: 'confluence-dc',
			connectorCategory: 'rovo_3p',
			pctUsersAuthed28d: 0.1,
			isUnderutilised: false,
			globalPctOrgsWithAnyAuthedUser: 22.2,
		},
		{
			connectorName: 'dropbox',
			connectorCategory: 'rovo_3p',
			pctUsersAuthed28d: 0.1,
			isUnderutilised: false,
			globalPctOrgsWithAnyAuthedUser: 41.7,
		},
		{
			connectorName: 'databricks',
			connectorCategory: 'rovo_3p',
			pctUsersAuthed28d: 0,
			isUnderutilised: false,
			globalPctOrgsWithAnyAuthedUser: 0,
		},
		{
			connectorName: 'workday',
			connectorCategory: 'rovo_3p',
			pctUsersAuthed28d: 0,
			isUnderutilised: false,
			globalPctOrgsWithAnyAuthedUser: 0,
		},
		{
			connectorName: 'miro',
			connectorCategory: 'rovo_3p',
			pctUsersAuthed28d: 2.8,
			isUnderutilised: false,
			globalPctOrgsWithAnyAuthedUser: 72.5,
		},
		{
			connectorName: 'webcrawler',
			connectorCategory: 'rovo_3p',
			pctUsersAuthed28d: 99.7,
			isUnderutilised: false,
			globalPctOrgsWithAnyAuthedUser: 71.9,
		},
		{
			connectorName: 'gmail',
			connectorCategory: 'rovo_3p',
			pctUsersAuthed28d: 4.3,
			isUnderutilised: false,
			globalPctOrgsWithAnyAuthedUser: 58.6,
		},
		{
			connectorName: 'google-calendar',
			connectorCategory: 'rovo_3p',
			pctUsersAuthed28d: 5.4,
			isUnderutilised: false,
			globalPctOrgsWithAnyAuthedUser: 61.5,
		},
		{
			connectorName: 'lite',
			connectorCategory: 'rovo_3p',
			pctUsersAuthed28d: 0,
			isUnderutilised: false,
			globalPctOrgsWithAnyAuthedUser: 0,
		},
		{
			connectorName: 'sharepoint',
			connectorCategory: 'rovo_3p',
			pctUsersAuthed28d: 2.8,
			isUnderutilised: false,
			globalPctOrgsWithAnyAuthedUser: 75.9,
		},
		{
			connectorName: 'lucid',
			connectorCategory: 'rovo_3p',
			pctUsersAuthed28d: 0.1,
			isUnderutilised: false,
			globalPctOrgsWithAnyAuthedUser: 54.6,
		},
		{
			connectorName: 'spinnaker',
			connectorCategory: 'rovo_3p',
			pctUsersAuthed28d: 0,
			isUnderutilised: false,
			globalPctOrgsWithAnyAuthedUser: 0,
		},
	],
	entitiesTouched: null,
	collaborators: null,
	collaboratorTeams: null,
	collaboratorTeamsTruncated: null,
} satisfies OrgMetricsResponse;

export const LOCAL_HAR_USER_METRICS = {
	workByCollaborators: {
		'ari:cloud:identity::user/712020:fe8c7aeb-92b9-4075-bfed-e4d859bb587f': [
			'ari:cloud:townsquare:a436116f-02ce-4520-8fbb-7301462a1674:project/2912ebb5-c146-4530-976c-c6e6723d6e90',
			'ari:cloud:jira:a436116f-02ce-4520-8fbb-7301462a1674:issue/11848067',
			'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/6970101932',
		],
		'ari:cloud:identity::user/63749bd0213a315af345637f': [
			'ari:cloud:jira:a436116f-02ce-4520-8fbb-7301462a1674:issue/9505770',
		],
		'ari:cloud:identity::user/712020:538b5dc0-5d53-4703-95be-0803cdd14327': [
			'ari:cloud:townsquare:a436116f-02ce-4520-8fbb-7301462a1674:project/2912ebb5-c146-4530-976c-c6e6723d6e90',
			'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/6812477983',
			'ari:cloud:graph::document/activation/a04080b6-0834-11eb-b374-0a77f3f45304/d10ad667-827d-4b3d-bc81-8126c3015198',
		],
		'ari:cloud:identity::user/63749bac9960988ef6bc6096': [
			'ari:cloud:townsquare:a436116f-02ce-4520-8fbb-7301462a1674:project/efeed1cf-2bce-4646-aa1f-6b93d7b452aa',
			'ari:cloud:jira:a436116f-02ce-4520-8fbb-7301462a1674:issue/9505770',
			'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/6970101932',
		],
		'ari:cloud:identity::user/712020:09586fae-19c1-4ffd-a4d3-06e8825ed043': [
			'ari:cloud:townsquare:a436116f-02ce-4520-8fbb-7301462a1674:project/efeed1cf-2bce-4646-aa1f-6b93d7b452aa',
			'ari:cloud:jira:a436116f-02ce-4520-8fbb-7301462a1674:issue/11848067',
			'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/6970101932',
		],
	},
	relationshipsByProvider: {
		confluence: {
			page: 79,
			database: 0,
			whiteboard: 2,
			space: 0,
			comment: 137,
		},
		jira: {
			workItem: 72,
			release: 0,
			comment: 258,
			worklog: 0,
		},
		loom: {
			video: 78,
			comment: 13,
		},
		atlas: {
			goal: 0,
			project: 2,
			goalUpdate: 0,
			projectUpdate: 36,
			comment: 2,
		},
		code: {
			comment: 43,
		},
		people: {
			team: 0,
		},
		compass: {
			component: 0,
		},
		mercury: {
			focus: 0,
		},
		google: {
			page: 9,
			calendarEvent: 321,
		},
		bitbucket: {
			pullRequest: 1614,
			commit: 642,
			branch: 10,
		},
		slack: {
			message: 2030,
			conversation: 2,
		},
	},
	peopleWorkedWithCount: 202,
	computedAt: '2026-05-05T19:26:40.612Z',
	meta: {
		batchOutcomes: {
			relationshipsByProvider: 'fulfilled',
			peopleWorkedWith: 'fulfilled',
			relationshipsCreated180d: 'fulfilled',
		},
	},
	relationshipsCreated180d: 8349,
} satisfies UserMicrositeHeroMetricsResponse;
